/** Digital SAT RW module order: Craft → Information and Ideas → Standard English Conventions → Expression of Ideas */
export const categories = {
  'Craft and Structure': 'craft_structure',
  'Information and Ideas': 'information_ideas',
  'Standard English Conventions': 'standard_english_conventions',
  'Expression of Ideas': 'expression_ideas',
};

export function categoryTitleForKey(categoryKey) {
  return Object.keys(categories).find((title) => categories[title] === categoryKey) ?? '';
}
